/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Permutationday1Inputs */



/**
* | output |
* | --- |
* | "Permutation day" |
*
* @param {Br_History_Key_Permutationday1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_permutationday1 = /** @type {((inputs?: Br_History_Key_Permutationday1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Permutationday1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Permutation day")
	return /** @type {LocalizedString} */ ("Jour de permutation")
});
export { br_history_key_permutationday1 as "br_history_key_permutationDay" }